import { createLazyResource, createMutation, createTriggerResource } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { ChecksRepository } from '~/repositories/checks';
import { emptyPlaceholder } from '~/utils/constant';
import { displayName } from '~/utils/strings';
import type { ChecksFilter } from '~/repositories/checks';
import type { NextCheckNumberDto } from '~/swagger/portal/Api';

const repo = new ChecksRepository();

export const [ChecksProvider, useChecks] = createMagicDoorContext('Checks', () => {
  const [checks, getChecks, checksActions] = createTriggerResource(async (filter?: ChecksFilter) => {
    const res = await repo.getChecks(filter);
    const items = res.items.map((item) => {
      const owner = res.owners?.find((owner) => owner.id === item.ownerId);
      const tenant = res.tenants?.find((tenant) => tenant.id === item.tenantId);
      const ownerName = displayName(owner?.firstName, owner?.lastName);
      const tenantName = displayName(tenant?.firstName, tenant?.lastName);
      return {
        ...item,
        vendorName: res.vendors?.find((vendor) => vendor.id === item.vendorId)?.name || emptyPlaceholder,
        ownerName: ownerName,
        tenantName: tenantName || emptyPlaceholder,
        bankAccountName: res.bankAccounts?.find((bankAccount) => bankAccount.id === item.bankAccountId)?.name || emptyPlaceholder,
      };
    });

    return {
      ...res,
      items,
    };
  });

  const [nextCheckNumber, nextCheckNumberActions] = createLazyResource(repo.getNextCheckNumber.bind(repo));

  const deleteCheck = createMutation(async (checkId: string) => {
    await repo.deleteCheck(checkId);
  });

  const updateNextCheckNumber = createMutation(async (payload: NextCheckNumberDto) => {
    await repo.updateNextCheckNumber(payload);
  });

  const getCheck = createMutation(async (id: string) => {
    return await repo.getCheck(id);
  });

  return {
    checks,
    getChecks,
    checksActions,

    get nextCheckNumber() {
      nextCheckNumberActions.fetch();
      return nextCheckNumber;
    },
    nextCheckNumberActions,

    deleteCheck,
    updateNextCheckNumber,
    getCheck,
  };
});
